import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover, PopoverHeader } from 'reactstrap';

const SessionsSharePopover = ({ title, url }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    const shareUrl = url || window.location.href;
    const shareTitle = title || '';

    const openShare = (network) => {
        let base = '';
        if (network === 'facebook') base = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        if (network === 'linkedin') base = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
        if (network === 'twitter') base = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`;

        window.open(base, '_blank', 'width=600,height=400');
    };

    return (
        <>
            <a
                id="session-share-trigger"
                className="share-trigger-modal"
                onClick={(e) => {
                    e.preventDefault();
                    toggle();
                }}
            >
                <span className="sr-only">Share</span>
            </a>

            <Popover
                placement="top"
                isOpen={isOpen}
                target="session-share-trigger"
                toggle={toggle}
                trigger="legacy"
                popperClassName="popover-react"
            >
                <PopoverHeader className="p-0 border-0">
                    <div className="addthis_toolbox bg-gray-dark d-flex p-2">
                        <div
                            className="share-button cursor-pointer"
                            onClick={() => openShare('facebook')}
                        >
                            <img src="/assets/images/facebook-white.svg" alt="FB" height="28" width="28" />
                        </div>
                        <div
                            className="share-button cursor-pointer"
                            onClick={() => openShare('linkedin')}
                        >
                            <img src="/assets/images/linkedIn-white.svg" alt="LI" height="28" width="28" />
                        </div>
                        <div
                            className="share-button cursor-pointer"
                            onClick={() => openShare('twitter')}
                        >
                            <img src="/assets/images/twitter-white.svg" alt="X" height="28" width="28" />
                        </div>
                    </div>
                </PopoverHeader>
            </Popover>
        </>
    );
};

SessionsSharePopover.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
};

export default SessionsSharePopover;